// Generated by ReScript, PLEASE EDIT WITH CARE


function toString(actionType) {
  if (actionType) {
    return "WHITELIST";
  } else {
    return "BLACKLIST";
  }
}

function toDisplayString(actionType) {
  if (actionType) {
    return "Whitelist Partner";
  } else {
    return "Blacklist Partner";
  }
}

function toDescription(actionType) {
  if (actionType) {
    return "Remove partner from blacklist after investigation";
  } else {
    return "Block partner's documents/device from being used";
  }
}

var allActionTypes = [
  /* Blacklist */0,
  /* Whitelist */1
];

export {
  toString ,
  toDisplayString ,
  toDescription ,
  allActionTypes ,
  
}
/* No side effect */
